module.exports = __webpack_public_path__ + "img/38.066b5b73.png";